import { useEffect } from 'react'

/**
 * A dialog over the page. Escape and the backdrop both close it.
 */
export function Modal({
  title,
  sub,
  icon,
  tone,
  wide,
  top,
  onClose,
  children,
  foot,
}: {
  title: string
  sub?: string
  icon?: string
  tone?: 'rose' | 'olive'
  wide?: boolean
  top?: boolean
  onClose: () => void
  children: React.ReactNode
  foot?: React.ReactNode
}) {
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', onKey)
    const previous = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      window.removeEventListener('keydown', onKey)
      document.body.style.overflow = previous
    }
  }, [onClose])

  return (
    <div
      className={top ? 'modal-back is-top' : 'modal-back'}
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose()
      }}
    >
      <div className={wide ? 'modal is-wide' : 'modal'} role="dialog" aria-modal="true" aria-label={title}>
        <div className="modal-head">
          <div className="who">
            {icon && (
              <span className={tone === 'olive' ? 'modal-icon is-olive' : 'modal-icon'}>
                <i className={`ph-bold ${icon}`} aria-hidden="true" />
              </span>
            )}
            <div>
              <h3 className="modal-title">{title}</h3>
              {sub && <span className="modal-sub">{sub}</span>}
            </div>
          </div>
          <button className="modal-x" type="button" onClick={onClose} aria-label="Close">
            <i className="ph-bold ph-x" aria-hidden="true" />
          </button>
        </div>
        <div className="modal-body">{children}</div>
        {foot && <div className="modal-foot">{foot}</div>}
      </div>
    </div>
  )
}
